import React from 'react';
import { ArrowLeft } from 'lucide-react';
import './PageContainer.css';

interface PageContainerProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  children: React.ReactNode;
  maxWidth?: string;
  className?: string;
}

const PageContainer: React.FC<PageContainerProps> = ({ 
  title, 
  subtitle, 
  onBack, 
  children, 
  maxWidth = '900px',
  className = ''
}) => {
  return (
    <div className={`page-container ${className}`}>
      <div className="page-content" style={{ maxWidth }}>
        {onBack && (
          <button onClick={onBack} className="page-back-button">
            <ArrowLeft size={16} />
            <span>Back</span>
          </button>
        )}
        
        <div className="page-header">
          <h1 className="page-title">{title}</h1>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
        
        <div className="page-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageContainer;